import { Box, Button, Container, Stack, TextField } from '@mui/material'
import { useState } from 'react'
import {
    createSearchParams,
    useNavigate,
    useSearchParams,
} from 'react-router-dom'
import { INNSYN_SEARCH_PATH, INNSYN_SEARCH_RESULTS_PATH } from '../../../paths'
import { FormattedMessage } from 'react-intl'
import NavigationHeader from '../../../components/NavigationHeader'

export const NameSearch = () => {
    const [query] = useSearchParams()
    const navigate = useNavigate()
    const [firstname, setFirstame] = useState<string>('')
    const [lastname, setLastname] = useState<string>('')

    const search = () => {
        query.set('search_type', 'name')
        query.set('fornavn', firstname)
        query.set('etternavn', lastname)
        navigate({
            pathname: INNSYN_SEARCH_RESULTS_PATH,
            search: `?${createSearchParams(query)}`,
        })
    }

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        setFunction: Function
    ) => {
        if (e.target.value.match(/^[\D]*$/)) {
            return setFunction(e.target.value)
        }
    }
    return (
        <Container sx={{ height: '100%', paddingTop: '0.5rem' }}>
            <NavigationHeader
                onClickBack={() => navigate(INNSYN_SEARCH_PATH)}
            />
            <Stack
                height={'90%'}
                justifyContent={'space-between'}
                sx={{ marginTop: '0.5rem' }}>
                <Stack
                    justifyContent={'space-around'}
                    spacing={'1.5rem'}
                    mb='25px'>
                    <Box
                        style={{
                            fontWeight: '300',
                            fontSize: '1.25rem',
                            marginTop: '1rem',
                        }}>
                        <FormattedMessage id={'name-search.search-name'} />
                    </Box>
                    <Box style={{ width: '100%' }}>
                        <p
                            style={{
                                fontWeight: '300',
                                marginBottom: '0.5rem',
                                fontSize: '1.1rem',
                            }}>
                            <FormattedMessage id={'name-search.first-name'} />
                        </p>
                        <form aria-label='fornavn' onSubmit={() => search()}>
                            <TextField
                                type='text'
                                value={firstname}
                                onChange={(e) => handleChange(e, setFirstame)}
                                id='fornavn'
                                label={
                                    <FormattedMessage
                                        id={'name-search.input-label'}
                                    />
                                }
                                variant='outlined'
                                sx={{ width: '100%' }}
                            />
                        </form>
                    </Box>

                    <Box style={{ marginBottom: '1rem', marginTop: '1rem' }}>
                        <p
                            style={{
                                fontWeight: '300',
                                marginBottom: '0.5rem',
                                fontSize: '1.1rem',
                            }}>
                            <FormattedMessage id={'name-search.last-name'} />
                        </p>
                        <form onSubmit={() => search()}>
                            <TextField
                                type='text'
                                value={lastname}
                                onChange={(e) => handleChange(e, setLastname)}
                                inputProps={{ 'aria-label': 'etternavn' }}
                                id='etternavn'
                                label={
                                    <FormattedMessage
                                        id={'name-search.input-label'}
                                    />
                                }
                                variant='outlined'
                                sx={{ width: '100%' }}
                            />
                        </form>
                    </Box>
                </Stack>
                <Button
                    onClick={() => search()}
                    size='medium'
                    variant='contained'
                    sx={{
                        bottom: '2rem',
                        width: '100%',
                    }}>
                    <FormattedMessage id={'name-search.search'} />
                </Button>
            </Stack>
        </Container>
    )
}

export default NameSearch
